import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { SecondClientDetailsDispatcher } from "./Variable";

export interface SecondClientDetailsStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class SecondClientDetailsStatic extends BaseStore<SecondClientDetailsStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(SecondClientDetailsDispatcher, (actionData) => this.onSecondClientDetailsStoreResponse(actionData));
    }

    public getLastResult(): SecondClientDetailsStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): SecondClientDetailsStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onSecondClientDetailsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
                case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
